import art1 from "./art/DashboardTemplateConfigArt1";
import art2 from "./art/DashboardTemplateConfigArt2";
import art3 from "./art/DashboardTemplateConfigArt3";
import art4 from "./art/DashboardTemplateConfigArt4";
import art5 from "./art/DashboardTemplateConfigArt5";
import art6 from "./art/DashboardTemplateConfigArt6";
import art7 from "./art/DashboardTemplateConfigArt7";
import type { FC } from "react";

const arts = [art1, art2, art3, art4, art5, art6, art7];

export type artStep = number | "last";

interface IDashboardTemplatesConfigArtProps {
    step: artStep;
}

export const DashboardTemplatesConfigArt: FC<IDashboardTemplatesConfigArtProps> = ({ step = 0 }) => {
    const Component = step == "last" ? arts[arts.length - 1] : arts[step];
    return <Component />;
};
